import { Bell, ChevronLeft, Settings, Share2 } from 'lucide-react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import type { ReactNode } from 'react'
import { getNotifications } from '@/api/notifications'
import NotificationSheet from '@/components/feature/NotificationSheet'

type Props = {
  title: string
  showBack?: boolean
  backFn?: () => void
  actions?: ReactNode
}

export default function Header({ title, showBack = false, backFn, actions }: Props) {
  const navigate = useNavigate()
  const [sheetOpen, setSheetOpen] = useState(false)

  const { data } = useQuery({
    queryKey: ['notifications'],
    queryFn: getNotifications,
    refetchInterval: 60000,
  })
  const unreadCount = data?.unread_count ?? 0

  const canShare = 'share' in navigator

  const handleShare = async () => {
    await navigator.share({ title: 'LIFE TROPHY', url: window.location.origin + '/' })
  }

  const handleBellClick = () => {
    setSheetOpen(true)
  }

  return (
    <>
      <header className="sticky top-0 z-10 flex h-14 items-center bg-background border-b px-4">
        {showBack && (
          <button
            type="button"
            onClick={() => backFn ? backFn() : navigate(-1)}
            className="mr-2 flex items-center justify-center min-h-[44px] min-w-[44px] -ml-2"
          >
            <ChevronLeft size={20} />
          </button>
        )}
        <h1 className="text-base font-semibold flex-1">{title}</h1>
        {actions}
        <button
          type="button"
          onClick={handleBellClick}
          className="relative flex items-center justify-center min-h-[44px] min-w-[44px] text-muted-foreground"
        >
          <Bell size={20} />
          {unreadCount > 0 && (
            <span className="absolute top-2 right-2 min-w-[16px] h-4 rounded-full bg-primary text-primary-foreground text-[10px] font-bold leading-4 text-center px-0.5">
              {unreadCount > 99 ? '99+' : unreadCount}
            </span>
          )}
        </button>
        {canShare && (
          <button
            type="button"
            onClick={handleShare}
            className="flex items-center justify-center min-h-[44px] min-w-[44px] text-muted-foreground"
          >
            <Share2 size={20} />
          </button>
        )}
        <button
          type="button"
          onClick={() => navigate('/settings')}
          className="flex items-center justify-center min-h-[44px] min-w-[44px] -mr-2 text-muted-foreground"
        >
          <Settings size={20} />
        </button>
      </header>
      <NotificationSheet open={sheetOpen} onClose={() => setSheetOpen(false)} />
    </>
  )
}
